import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { TrailingColumnComponentProps } from './types';

const trailingColumnBaseStyle = css`
  display: flex;
  grid-column-end: trail;
  grid-column-start: trail;
  grid-row-end: trail;
  grid-row-start: trail;
  padding-left: ${theme.spacing(2)};
  flex-direction: column;
  align-items: flex-end;

  .trailing-column-child {
    margin-top: 0;
    margin-right: 0;
    margin-bottom: ${theme.spacing(0.25)};
    margin-left: 0;
    text-transform: capitalize;
  }
  button {
    &:hover:not([disabled]) {
      background-color: ${theme.colors.neutral20} !important;
    }
  }
`;

const trailingColumnAlignStyles = {
  center: css`
    justify-content: center;
    .trailing-column-child {
      font-size: ${theme.fontSize(16)};
    }
  `,
  'flex-start': css`
    justify-content: flex-start;
    .trailing-column-child {
      font-size: ${theme.fontSize(14)};
    }
  `,
};

export const trailingColumnStyles = ({ verticalAlign = 'center' }: TrailingColumnComponentProps) =>
  cx(trailingColumnBaseStyle, trailingColumnAlignStyles[verticalAlign]);
